import type { Meta, StoryObj } from '@storybook/web-components';

// @ts-expect-error
import theme from '../../styles/theme.css?inline';

// This default export determines where your story goes in the story list
const meta: Meta = {
  title: 'Components/Widget',
  tags: ['autodocs'],
  render: args => {
    return `
      <hr-widget url="${args.url}" token="${args.token}" resource="${args.resource}"></hr-widget>
      <script>
        document.querySelector('hr-widget').addEventListener('reaction', ${args.onReaction});
        document.querySelector('hr-widget').classes = JSON.parse('${JSON.stringify(args.classes)}');
      </script>
    `;
  },
  argTypes: {
    token: { control: 'text' },
    resource: { control: 'text' },
    url: { control: 'text' },
    classes: { control: 'object' },
  },
  args: {
    url: 'http://localhost:4000',
    token: '2c0437fd-eb89-47f5-b472-5d901bedfe6c',
    resource: 'storybook-primary',
    onReaction: event => {
      console.log('ON REACTION', event.detail);
    },
    classes: {},
  },
  decorators: [
    story => `
    <style>${theme}</style>
    ${story()}
  `,
  ],
};
export default meta;

type Story = StoryObj;

export const Primary: Story = {
  args: {
    classes: {
      root: 'root',
    },
  },
};

export const Themes: Story = {};
